// extracted by mini-css-extract-plugin
var _1 = "LGUXzLinhEdt5zdVBA7j";
var _2 = "DLVqlLDtibgYdm6zMFAR";
export { _1 as "notop", _2 as "root" }
